var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconTurnImage = function SvgIconTurnImage(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-4487fd4a-473d-4618-a006-b52e80db5e5b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .uuid-3465e564-f3d8-4d1e-aba5-63daae31f8b8{fill:#393939;isolation:isolate;opacity:.6;}.uuid-3465e564-f3d8-4d1e-aba5-63daae31f8b8,.uuid-0721e0f5-8c5c-4cef-9eb8-cf88aba3d306{stroke-width:0px;}.uuid-0721e0f5-8c5c-4cef-9eb8-cf88aba3d306{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-4975d003-3339-4dfc-bc34-7022832bca14"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "uuid-a46c13db-f42f-4e9f-a47d-4552e7831789",
    className: "uuid-3465e564-f3d8-4d1e-aba5-63daae31f8b8",
    cx: 20,
    cy: 20,
    r: 19.84
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-34e7cd0a-bf0f-4195-9c2f-3696876df699",
    className: "uuid-0721e0f5-8c5c-4cef-9eb8-cf88aba3d306",
    d: "M19.33,9.95c0,.37.3.67.67.67,5.18,0,9.38,4.2,9.38,9.38,0,2.46-.96,4.81-2.68,6.57v-1.87c-.01-.37-.33-.66-.7-.64-.35.01-.63.29-.64.64v4.02h4.02c.37-.01.66-.33.64-.7-.01-.35-.29-.63-.64-.64h-1.6c4.07-4.3,3.89-11.08-.41-15.16-1.99-1.89-4.63-2.94-7.38-2.94-.37,0-.67.3-.67.67h0ZM12.42,27.58c2.01,2.02,4.74,3.15,7.58,3.14.37-.01.66-.33.64-.7-.01-.35-.29-.63-.64-.64-5.18,0-9.38-4.2-9.38-9.38,0-2.46.96-4.81,2.68-6.57v1.87c.01.37.33.66.7.64.35-.01.63-.29.64-.64v-4.02h-4.02c-.37.01-.66.33-.64.7.01.35.29.63.64.64h1.6c-4,4.21-3.91,10.85.2,14.96h0Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconTurnImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-turnImage.0a64c324db5fab85c70ce2b13a1428c0.svg";